import type { ReplyEmailItem } from "hooks/use-email-replies-api";
import { MailPlus } from "lucide-react";
import type { FC } from "react";

import { InlineReplyComposer } from "./InlineReplyComposer";

export type ReplyComposerColumnProps = {
  /** 返信対象 (未選択時は null) */
  reply: ReplyEmailItem | null;
  /** Gmail 連携が有効か。false なら送信不可 */
  canCompose: boolean;
  /** 送信成功時のコールバック (一覧 refetch 等) */
  onSent: () => void;
};

/**
 * メール返信フォームカラム本文. 返信対象が選択されていればフル機能の返信フォーム
 * (送信元 / 宛先 / CC / BCC / 件名 / AI 生成 / 送信) を表示し、未選択時はプレースホルダを出す.
 * @param {ReplyComposerColumnProps} props 返信対象とハンドラ
 * @return {JSX.Element} 返信フォームカラム本文
 */
export const ReplyComposerColumn: FC<ReplyComposerColumnProps> = ({
  reply,
  canCompose,
  onSent,
}) => {
  if (!reply) {
    return (
      <div className="h-full flex flex-col items-center justify-center gap-2 text-sm text-base-content/60 px-4 text-center">
        <MailPlus size={28} className="text-slate-300" aria-hidden />
        返信するメールを選択してください
      </div>
    );
  }

  return (
    <div className="px-4 py-3">
      <InlineReplyComposer
        key={reply.id}
        reply={reply}
        canCompose={canCompose}
        onSent={onSent}
      />
    </div>
  );
};
